!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("d3"), require("nvd3")) : "function" == typeof define && define.amd ? define(["react", "d3", "nvd3"], e) : "object" == typeof exports ? exports.NVD3Chart = e(require("react"), require("d3"), require("nvd3")) : t.NVD3Chart = e(t.React, t.d3, t.nv);
}(this, function (t, e, n) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.p = "", e(0);
  }([function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(1),
        i = r(o),
        u = n(2),
        c = r(u),
        s = n(17),
        a = r(s),
        f = n(21),
        l = r(f),
        p = n(22),
        d = r(p),
        h = n(25),
        y = r(h),
        v = n(48),
        g = r(v),
        b = n(55),
        m = r(b),
        _ = n(56),
        x = r(_),
        w = n(57),
        O = r(w),
        k = n(58),
        j = ["x", "y", "type", "datum", "configure"],
        S = ["width", "height"],
        C = "margin",
        P = "containerStyle",
        E = "renderStart",
        M = "renderEnd",
        D = "ready",
        z = function (t) {
      function e() {
        (0, l["default"])(this, e);
        var t = (0, y["default"])(this, (e.__proto__ || (0, a["default"])(e)).call(this));
        return t.resize = t.resize.bind(t), t;
      }

      return (0, g["default"])(e, t), (0, d["default"])(e, [{
        key: "componentDidMount",
        value: function value() {
          var t = this;
          O["default"].addGraph(this.renderChart.bind(this), function (e) {
            (0, k.isCallable)(t.props.ready) && t.props.ready(e, D);
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this.renderChart();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.resizeHandler && clearTimeout(this.resizeHandler), window.removeEventListener ? window.removeEventListener("resize", this.resize) : window.detachEvent("resize", this.resize);
        }
      }, {
        key: "renderChart",
        value: function value() {
          var t = void 0;

          switch (this.chart = this.chart && !this.rendering ? this.chart : O["default"].models[this.props.type](), (0, k.isCallable)(this.props.renderStart) && this.props.renderStart(this.chart, E), this.parsedProps = (0, k.bindFunctions)(this.props, this.props.context), this.chart.x && this.chart.x((0, k.getValueFunction)(this.parsedProps.x, "x")), this.chart.y && this.chart.y((0, k.getValueFunction)(this.parsedProps.y, "y")), this.props.margin && this.chart.margin(this.options(C, k.pick).margin || (0, k.propsByPrefix)("margin", this.props) || {}), this.configureComponents(this.chart, this.options(j.concat(P), k.without)), !this.props.configure || this.props.configure(this.chart), this.selection = x["default"].select(this.refs.svg).datum(this.props.datum).call(this.chart), this.resizeHandler || (window.addEventListener ? window.addEventListener("resize", this.resize, !1) : window.attachEvent("resize", this.resize, !1)), this.props.type) {
            case "multiBarChart":
              t = this.chart.multibar.dispatch;
              break;

            case "pieChart":
              t = this.chart.pie.dispatch;
              break;

            case "lineChart":
            case "linePlusBarChart":
              t = this.chart.lines.dispatch;
              break;

            default:
              t = this.chart.dispatch;
          }

          return t.renderEnd && t.on("renderEnd", this.renderEnd.bind(this)), t.elementClick && t.on("elementClick", this.elementClick.bind(this)), this.props.legend && this.props.legend.legendClick && this.chart.legend && this.chart.legend.dispatch && this.chart.legend.dispatch.on("legendClick", this.legendClick.bind(this)), this.props.legend && this.props.legend.legendDblclick && this.chart.legend && this.chart.legend.dispatch && this.chart.legend.dispatch.on("legendDblclick", this.legendDblclick.bind(this)), this.rendering = !0, this.chart;
        }
      }, {
        key: "renderEnd",
        value: function value(t) {
          (0, k.isCallable)(this.props.renderEnd) && this.props.renderEnd(this.chart, M), this.rendering = !1;
        }
      }, {
        key: "elementClick",
        value: function value(t) {
          (0, k.isCallable)(this.props.elementClick) && this.props.elementClick(t, "elementClick");
        }
      }, {
        key: "legendClick",
        value: function value(t, e) {
          (0, k.isCallable)(this.props.legend.legendClick) && this.props.legend.legendClick(this.chart, "legendClick");
        }
      }, {
        key: "legendDblclick",
        value: function value(t, e) {
          (0, k.isCallable)(this.props.legend.legendDblclick) && this.props.legend.legendDblclick(this.chart, "legendDblclick");
        }
      }, {
        key: "configureComponents",
        value: function value(t, e) {
          for (var n in e) {
            var r = e[n];
            t && ((0, k.isPlainObject)(r) ? this.configureComponents(t[n], r) : "function" == typeof t[n] && t[n](r));
          }
        }
      }, {
        key: "options",
        value: function value(t, e) {
          var n = this.parsedProps.options || this.parsedProps || this.props.chartOptions;
          return (e = e || k.pick)(n, t);
        }
      }, {
        key: "resize",
        value: function value(t) {
          var e = this;
          clearTimeout(this.resizeHandler), this.resizeHandler = setTimeout(function () {
            clearTimeout(e.resizeHandler), e.chart && "function" == typeof e.chart.update && e.chart.update();
          }, 250);
        }
      }, {
        key: "render",
        value: function value() {
          var t = (0, k.pick)(this.props, S),
              e = (0, c["default"])({}, t, this.props.containerStyle);
          return m["default"].createElement("div", {
            ref: "root",
            className: "nv-chart",
            style: e
          }, m["default"].createElement("svg", (0, i["default"])({
            ref: "svg"
          }, t)));
        }
      }]), e;
    }(m["default"].Component);

    e["default"] = z, t.exports = z;
  }, function (t, e, n) {
    "use strict";

    var r = n(2)["default"];
    e["default"] = r || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }, e.__esModule = !0;
  }, function (t, e, n) {
    t.exports = {
      "default": n(3),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(4), t.exports = n(7).Object.assign;
  }, function (t, e, n) {
    var r = n(5);
    r(r.S + r.F, "Object", {
      assign: n(10)
    });
  }, function (t, e, n) {
    var r = n(6),
        o = n(7),
        i = n(8),
        u = "prototype",
        c = function c(t, e, n) {
      var s,
          a,
          f,
          l = t & c.F,
          p = t & c.G,
          d = t & c.S,
          h = t & c.P,
          y = t & c.B,
          v = t & c.W,
          g = p ? o : o[e] || (o[e] = {}),
          b = p ? r : d ? r[e] : (r[e] || {})[u];
      p && (n = e);

      for (s in n) {
        a = !l && b && s in b, a && s in g || (f = a ? b[s] : n[s], g[s] = p && "function" != typeof b[s] ? n[s] : y && a ? i(f, r) : v && b[s] == f ? function (t) {
          var e = function e(_e) {
            return this instanceof t ? new t(_e) : t(_e);
          };

          return e[u] = t[u], e;
        }(f) : h && "function" == typeof f ? i(Function.call, f) : f, h && ((g[u] || (g[u] = {}))[s] = f));
      }
    };

    c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, t.exports = c;
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e) {
    var n = t.exports = {
      version: "1.2.6"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(9);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(11),
        o = n(12),
        i = n(14);
    t.exports = n(16)(function () {
      var t = Object.assign,
          e = {},
          n = {},
          r = Symbol(),
          o = "abcdefghijklmnopqrst";
      return e[r] = 7, o.split("").forEach(function (t) {
        n[t] = t;
      }), 7 != t({}, e)[r] || Object.keys(t({}, n)).join("") != o;
    }) ? function (t, e) {
      for (var n = o(t), u = arguments, c = u.length, s = 1, a = r.getKeys, f = r.getSymbols, l = r.isEnum; c > s;) {
        for (var p, d = i(u[s++]), h = f ? a(d).concat(f(d)) : a(d), y = h.length, v = 0; y > v;) {
          l.call(d, p = h[v++]) && (n[p] = d[p]);
        }
      }

      return n;
    } : Object.assign;
  }, function (t, e) {
    var n = Object;
    t.exports = {
      create: n.create,
      getProto: n.getPrototypeOf,
      isEnum: {}.propertyIsEnumerable,
      getDesc: n.getOwnPropertyDescriptor,
      setDesc: n.defineProperty,
      setDescs: n.defineProperties,
      getKeys: n.keys,
      getNames: n.getOwnPropertyNames,
      getSymbols: n.getOwnPropertySymbols,
      each: [].forEach
    };
  }, function (t, e, n) {
    var r = n(13);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e, n) {
    var r = n(15);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (e) {
        return !0;
      }
    };
  }, function (t, e, n) {
    t.exports = {
      "default": n(18),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(19), t.exports = n(7).Object.getPrototypeOf;
  }, function (t, e, n) {
    var r = n(12);
    n(20)("getPrototypeOf", function (t) {
      return function (e) {
        return t(r(e));
      };
    });
  }, function (t, e, n) {
    var r = n(5),
        o = n(7),
        i = n(16);

    t.exports = function (t, e) {
      var n = (o.Object || {})[t] || Object[t],
          u = {};
      u[t] = e(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", u);
    };
  }, function (t, e) {
    "use strict";

    e.__esModule = !0, e["default"] = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    e.__esModule = !0;
    var o = n(23),
        i = r(o);

    e["default"] = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, i["default"])(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }();
  }, function (t, e, n) {
    t.exports = {
      "default": n(24),
      __esModule: !0
    };
  }, function (t, e, n) {
    var r = n(11);

    t.exports = function (t, e, n) {
      return r.setDesc(t, e, n);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    e.__esModule = !0;
    var o = n(26),
        i = r(o);

    e["default"] = function (t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" !== ("undefined" == typeof e ? "undefined" : (0, i["default"])(e)) && "function" != typeof e ? t : e;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(27)["default"];
    e["default"] = function (t) {
      return t && t.constructor === r ? "symbol" : typeof t;
    }, e.__esModule = !0;
  }, function (t, e, n) {
    t.exports = {
      "default": n(28),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(29), n(47), t.exports = n(7).Symbol;
  }, function (t, e, n) {
    "use strict";

    var r = n(11),
        o = n(6),
        i = n(30),
        u = n(31),
        c = n(5),
        s = n(32),
        a = n(16),
        f = n(35),
        l = n(36),
        p = n(38),
        d = n(37),
        h = n(39),
        y = n(41),
        v = n(42),
        g = n(43),
        b = n(44),
        m = n(40),
        _ = n(34),
        x = r.getDesc,
        w = r.setDesc,
        O = r.create,
        k = y.get,
        j = o.Symbol,
        S = o.JSON,
        C = S && S.stringify,
        P = !1,
        E = d("_hidden"),
        M = r.isEnum,
        D = f("symbol-registry"),
        z = f("symbols"),
        F = "function" == typeof j,
        N = Object.prototype,
        T = u && a(function () {
      return 7 != O(w({}, "a", {
        get: function get() {
          return w(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, n) {
      var r = x(N, e);
      r && delete N[e], w(t, e, n), r && t !== N && w(N, e, r);
    } : w,
        q = function q(t) {
      var e = z[t] = O(j.prototype);
      return e._k = t, u && P && T(N, t, {
        configurable: !0,
        set: function set(e) {
          i(this, E) && i(this[E], t) && (this[E][t] = !1), T(this, t, _(1, e));
        }
      }), e;
    },
        B = function B(t) {
      return "symbol" == typeof t;
    },
        A = function A(t, e, n) {
      return n && i(z, e) ? (n.enumerable ? (i(t, E) && t[E][e] && (t[E][e] = !1), n = O(n, {
        enumerable: _(0, !1)
      })) : (i(t, E) || w(t, E, _(1, {})), t[E][e] = !0), T(t, e, n)) : w(t, e, n);
    },
        H = function H(t, e) {
      b(t);

      for (var n, r = v(e = m(e)), o = 0, i = r.length; i > o;) {
        A(t, n = r[o++], e[n]);
      }

      return t;
    },
        V = function V(t, e) {
      return void 0 === e ? O(t) : H(O(t), e);
    },
        W = function W(t) {
      var e = M.call(this, t);
      return !(e || !i(this, t) || !i(z, t) || i(this, E) && this[E][t]) || e;
    },
        G = function G(t, e) {
      var n = x(t = m(t), e);
      return !n || !i(z, e) || i(t, E) && t[E][e] || (n.enumerable = !0), n;
    },
        I = function I(t) {
      for (var e, n = k(m(t)), r = [], o = 0; n.length > o;) {
        i(z, e = n[o++]) || e == E || r.push(e);
      }

      return r;
    },
        J = function J(t) {
      for (var e, n = k(m(t)), r = [], o = 0; n.length > o;) {
        i(z, e = n[o++]) && r.push(z[e]);
      }

      return r;
    },
        K = function K(t) {
      if (void 0 !== t && !B(t)) {
        for (var e, n, r = [t], o = 1, i = arguments; i.length > o;) {
          r.push(i[o++]);
        }

        return e = r[1], "function" == typeof e && (n = e), !n && g(e) || (e = function e(t, _e2) {
          if (n && (_e2 = n.call(this, t, _e2)), !B(_e2)) return _e2;
        }), r[1] = e, C.apply(S, r);
      }
    },
        L = a(function () {
      var t = j();
      return "[null]" != C([t]) || "{}" != C({
        a: t
      }) || "{}" != C(Object(t));
    });

    F || (j = function j() {
      if (B(this)) throw TypeError("Symbol is not a constructor");
      return q(p(arguments.length > 0 ? arguments[0] : void 0));
    }, s(j.prototype, "toString", function () {
      return this._k;
    }), B = function B(t) {
      return t instanceof j;
    }, r.create = V, r.isEnum = W, r.getDesc = G, r.setDesc = A, r.setDescs = H, r.getNames = y.get = I, r.getSymbols = J, u && !n(46) && s(N, "propertyIsEnumerable", W, !0));
    var R = {
      "for": function _for(t) {
        return i(D, t += "") ? D[t] : D[t] = j(t);
      },
      keyFor: function keyFor(t) {
        return h(D, t);
      },
      useSetter: function useSetter() {
        P = !0;
      },
      useSimple: function useSimple() {
        P = !1;
      }
    };
    r.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), function (t) {
      var e = d(t);
      R[t] = F ? e : q(e);
    }), P = !0, c(c.G + c.W, {
      Symbol: j
    }), c(c.S, "Symbol", R), c(c.S + c.F * !F, "Object", {
      create: V,
      defineProperty: A,
      defineProperties: H,
      getOwnPropertyDescriptor: G,
      getOwnPropertyNames: I,
      getOwnPropertySymbols: J
    }), S && c(c.S + c.F * (!F || L), "JSON", {
      stringify: K
    }), l(j, "Symbol"), l(Math, "Math", !0), l(o.JSON, "JSON", !0);
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    t.exports = !n(16)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    t.exports = n(33);
  }, function (t, e, n) {
    var r = n(11),
        o = n(34);
    t.exports = n(31) ? function (t, e, n) {
      return r.setDesc(t, e, o(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e, n) {
    var r = n(6),
        o = "__core-js_shared__",
        i = r[o] || (r[o] = {});

    t.exports = function (t) {
      return i[t] || (i[t] = {});
    };
  }, function (t, e, n) {
    var r = n(11).setDesc,
        o = n(30),
        i = n(37)("toStringTag");

    t.exports = function (t, e, n) {
      t && !o(t = n ? t : t.prototype, i) && r(t, i, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    var r = n(35)("wks"),
        o = n(38),
        i = n(6).Symbol;

    t.exports = function (t) {
      return r[t] || (r[t] = i && i[t] || (i || o)("Symbol." + t));
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e, n) {
    var r = n(11),
        o = n(40);

    t.exports = function (t, e) {
      for (var n, i = o(t), u = r.getKeys(i), c = u.length, s = 0; c > s;) {
        if (i[n = u[s++]] === e) return n;
      }
    };
  }, function (t, e, n) {
    var r = n(14),
        o = n(13);

    t.exports = function (t) {
      return r(o(t));
    };
  }, function (t, e, n) {
    var r = n(40),
        o = n(11).getNames,
        i = {}.toString,
        u = "object" == typeof window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        c = function c(t) {
      try {
        return o(t);
      } catch (e) {
        return u.slice();
      }
    };

    t.exports.get = function (t) {
      return u && "[object Window]" == i.call(t) ? c(t) : o(r(t));
    };
  }, function (t, e, n) {
    var r = n(11);

    t.exports = function (t) {
      var e = r.getKeys(t),
          n = r.getSymbols;
      if (n) for (var o, i = n(t), u = r.isEnum, c = 0; i.length > c;) {
        u.call(t, o = i[c++]) && e.push(o);
      }
      return e;
    };
  }, function (t, e, n) {
    var r = n(15);

    t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    var r = n(45);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    var r = n(49)["default"],
        o = n(51)["default"];
    e["default"] = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = r(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (o ? o(t, e) : t.__proto__ = e);
    }, e.__esModule = !0;
  }, function (t, e, n) {
    t.exports = {
      "default": n(50),
      __esModule: !0
    };
  }, function (t, e, n) {
    var r = n(11);

    t.exports = function (t, e) {
      return r.create(t, e);
    };
  }, function (t, e, n) {
    t.exports = {
      "default": n(52),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(53), t.exports = n(7).Object.setPrototypeOf;
  }, function (t, e, n) {
    var r = n(5);
    r(r.S, "Object", {
      setPrototypeOf: n(54).set
    });
  }, function (t, e, n) {
    var r = n(11).getDesc,
        o = n(45),
        i = n(44),
        u = function u(t, e) {
      if (i(t), !o(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };

    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, o) {
        try {
          o = n(8)(Function.call, r(Object.prototype, "__proto__").set, 2), o(t, []), e = !(t instanceof Array);
        } catch (i) {
          e = !0;
        }

        return function (t, n) {
          return u(t, n), e ? t.__proto__ = n : o(t, n), t;
        };
      }({}, !1) : void 0),
      check: u
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, n) {
    t.exports = e;
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    function o(t, e) {
      return t.indexOf(e) >= 0;
    }

    function i(t) {
      return function () {
        return !t.apply(this, arguments);
      };
    }

    function u(t, e, n) {
      for (var r = {}, o = (0, m["default"])(t), i = 0, u = o.length; i < u; i++) {
        var c = o[i],
            s = t[c];
        n(e, c) && (r[c] = s);
      }

      return r;
    }

    function c(t, e) {
      return u(t, e, o);
    }

    function s(t, e) {
      return u(t, e, i(o));
    }

    function a(t) {
      if ("object" == ("undefined" == typeof t ? "undefined" : (0, g["default"])(t)) && null !== t) {
        if ("function" == typeof y["default"]) {
          var e = (0, y["default"])(t);
          return e === Object.prototype || null === e;
        }

        return "[object Object]" == Object.prototype.toString.call(t);
      }

      return !1;
    }

    function f(t, e) {
      var n, r, o;
      n = Array.isArray(t) ? [] : {};

      for (o in t) {
        r = t[o], null != r && ("object" === ("undefined" == typeof r ? "undefined" : (0, g["default"])(r)) && null !== r && "function" !== r.type ? n[o] = f(r, e) : "function" === r.type ? n[o] = e[r.name] : n[o] = r);
      }

      return n;
    }

    function l(t, e) {
      return "function" == typeof t ? t : function (n) {
        return "undefined" != typeof n[t] ? n[t] : n[e];
      };
    }

    function p(t, e) {
      return console.warn("Set margin with prefixes is deprecated use an object instead"), t += "-", (0, m["default"])(e).reduce(function (n, r) {
        return r.substr(0, t.length) === t && (n[r.replace(t, "")] = e[r]), n;
      }, {});
    }

    function d(t) {
      return Boolean(t && "function" == typeof t);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var h = n(17),
        y = r(h),
        v = n(26),
        g = r(v),
        b = n(59),
        m = r(b);
    e.includes = o, e.negate = i, e.pick = c, e.without = s, e.isPlainObject = a, e.bindFunctions = f, e.getValueFunction = l, e.propsByPrefix = p, e.isCallable = d;
  }, function (t, e, n) {
    t.exports = {
      "default": n(60),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(61), t.exports = n(7).Object.keys;
  }, function (t, e, n) {
    var r = n(12);
    n(20)("keys", function (t) {
      return function (e) {
        return t(r(e));
      };
    });
  }]);
});